import * as React from "react";

import CountDown from "../CountDown";
import { DoubleCardWrap } from "../styles.card";
import { ProductCardProps } from "./index";

import { BannerContainer } from "../../../../components/BannerContainer";
import { ProductInfoGrid2 } from "../../../LayerUI/ProductInfoViews";
import { ProductImageTagViews } from "../../../LayerUI/ImageTagViews";
import { LinkTargetType } from "../../../../services/playground";
import { transformAParam } from "utils/browser";
import { PoolExtraInfo } from "../../../../services/product";

const DoubleCard = (props: ProductCardProps) => {
	const {
		productElement,
		stylesForCard = {},
		columnNum,
		layoutStyle,
		placeholderBg,
		qnParams = {},
		isInApp,
		collectOptions = {},
		displayInfo,
		poolId,
	} = props;
	const {
		imgOnBottomLeft,
		imgOnTopLeft,
		imgOnTopRight,
		titleIcon,
		collect,
		actTags,
		shipIn24hours,
		flash,
	} = productElement.extra || ({} as PoolExtraInfo);

	const aProps = transformAParam({
		isInApp: !!isInApp,
		link: productElement.url,
		aTarget: LinkTargetType.Blank,
		onClick: props.onClick,
	});

	return (
		<DoubleCardWrap
			isRollable={props.isRollable}
			{...aProps}
			id={`${poolId}${productElement.gpid}`}
		>
			<BannerContainer
				banner={{
					img: productElement.img,
					link: productElement.url,
				}}
				style={{
					...stylesForCard,
				}}
				className={"productPictureWrap"}
				placeholderBg={placeholderBg}
				qnParams={{ ...qnParams }}
				keepSize={true}
			>
				<ProductImageTagViews
					columnNum={2}
					rightTopTag={imgOnTopRight}
					leftTopTag={imgOnTopLeft}
					leftBottomTag={imgOnBottomLeft}
				/>
				{flash?.countdownToEnd && <CountDown countInfo={flash} needIcon={true} />}
			</BannerContainer>

			<ProductInfoGrid2
				columnNum={columnNum || 2}
				price={productElement.price}
				originalPrice={productElement.originPrice}
				name={productElement.name}
				titleIcon={titleIcon?.img}
				collect={collect}
				collectOptions={collectOptions}
				actTags={actTags}
				layoutStyle={layoutStyle}
				shipIn24hours={shipIn24hours}
				displayInfo={displayInfo}
			/>
		</DoubleCardWrap>
	);
};

export default DoubleCard;
